import * as Yup from "yup";
import { useFormik } from "formik";
import { registeringForm } from "../../../utils/string";
import Upload from "../../../assets/Images/Upload.svg";
import { useEffect, useRef, useState } from "react";
import {
  addAsset,
  addAssetAdvertisements,
  getAssetMake,
  getAssetStatuses,
  getContactById,
  savePicture,
  uploadBulkImg,
  addLocation,
  checkUnitNumber,
  addCategori,
} from "../../../services/vizyBilityServices";
import { toast } from "react-toastify";
import GooglePlacesAutocomplete from "react-google-autocomplete";
import { cleanObjectKeys, fileToBlob, formatDate, logoutFun } from "../../../utils/helper";
import SignUpWarningModel from "../../model/signUpWarningModel";
import { useNavigate } from "react-router-dom";
import WarningModal from "../../model/warningModel";
import { useMsal } from "@azure/msal-react";
import { ApplicationId, DefaultAssetID, Google_map_Key, vizybilityConfig } from "../../../api/url";
import { jwtDecode } from "jwt-decode";
import { postGetVizyBilityToken } from "../../../services/getVizyBilityToken";
import { getAzureUser } from "../../../services/updateAzureUser";
import { loginRequest } from "../../../config/msalConfig";
import { getGenericUserKey, getThirdPartyAzureService } from "../../../services/getThirdPartyAzureService";
import { WithLogInForm, WithoutLogInForm } from "../../validation/AddMachineFormvalidation";
import { getAllMachinesCategoryList, getAllMachinesMaketList, getCategoryList, getMasterModelsByMake } from "../../../services/machineService";
import Select from "../../form/Select";

const AddMachineForm = () => {
  const navigate = useNavigate();
  const { instance, accounts } = useMsal();
  const Logout = localStorage.getItem("getAzureUserData");
  const [openWarning, setOpenWarning] = useState(false);
  const [previewImage, setPreviewImage] = useState(null); // Image for modal preview
  const [images, setImages] = useState(JSON.parse(localStorage.getItem("StoreMachineImg")) || []);
  const [assetType, setAssetType] = useState([]);
  const [assetStatus, setAssetStatus] = useState([]);
  const [assetMake, setAssetMake] = useState([]);
  const [assetModel, setAssetModel] = useState([]);
  const [addMachineLoader, setAddMachineLoader] = useState(false);
  const [refreshPage, setRefreshPage] = useState(false);
  const [openPendingWarning, setOpenPendingWarning] = useState(localStorage.getItem("OpenWarning") || false);

  const [isLoading, setIsLoading] = useState(false);
  const azureUserInfo = localStorage.getItem("getAzureUserData")
    ? JSON.parse(localStorage.getItem("getAzureUserData") || {})
    : null;

  const inputRef = useRef(null);
  const formik = useFormik({
    initialValues: {
      year: "",
      type: "",
      model: "",
      serialNumber: "",
      manufacturers: "",
      machineHours: "",
      smu: formatDate(new Date()),
      description: "",
      status: 1,
      price: "",
      currency: "USD",
      sortOrder: "1",
      images: [],
    },
    validationSchema: Logout ? WithoutLogInForm : WithLogInForm,
    onSubmit: (values) => {
      if (Logout) {
        handleCheckUnitNumber(values);
      } else {
        localStorage.setItem("StoreMachineData", JSON.stringify(values));
        localStorage.setItem("StoreMachineImg", JSON.stringify(images));
        setOpenWarning(true);
      }
    },
  });

  useEffect(() => {
    if (localStorage.getItem("StoreMachineData")) {
      const storedData = JSON.parse(localStorage.getItem("StoreMachineData"));
      const data = {
        ...storedData,
        images: JSON.parse(localStorage.getItem("StoreMachineImg")) || [], // Override the images property
      };
      formik.setValues(data); // Set the formik values
    }
  }, []);

  useEffect(() => {
    handleGetAssetType();
    handleGetAssetMake();
    if (Logout) {
      handleGetAssetStatus();
    }
  }, [refreshPage]);

  useEffect(() => {
    if (isLoading || addMachineLoader) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [isLoading, addMachineLoader]);

  // Fetch models when manufacturer/make changes (including on edit/load from storage)
  useEffect(() => {
    if (formik.values.manufacturers && assetMake.length > 0) {
      const selectedMake = assetMake.find((item) => item.MakeId == formik.values.manufacturers);
      if (selectedMake) {
        handleGetAssetModel(selectedMake.MakeName);
      }
    }
  }, [formik.values.manufacturers, assetMake]);


  const handleGetAssetType = () => {
    getAllMachinesCategoryList()
      .then((res) => {
        setAssetType(res.data.find((item) => item.AssetTypeId === 2)?.CategoryDetails);
      })
      .catch((err) => {
        if (err?.status == 401 || err?.statusText == "Unauthorized") {
          logoutFun(instance);
        }
      });
  };

  const handleGetAssetStatus = () => {
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    getAssetStatuses(header, instance, accounts)
      .then((res) => {
        setAssetStatus(res.data);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const handleGetAssetMake = () => {
    getAllMachinesMaketList(false)
      .then((res) => {
        setAssetMake(res.data);
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const handleGetAssetModel = (makeName) => {
    console.log("Fetching models for make:", makeName);

    const payload = {
      applicationId: ApplicationId,
      makeName: [makeName],
      isFromAdvertisement: false
    };

    getMasterModelsByMake(payload)
      .then((res) => {
        console.log("Models fetched successfully:", res.data);
        setAssetModel(res.data);

        // Check if current model value exists in the new model list
        const currentModel = formik.values.model;
        if (currentModel) {
          const modelExists = res.data.some((item) => item.ModelName === currentModel);
          if (!modelExists) {
            // Model doesn't exist in new list, clear it to show placeholder
            console.log("Current model not found in new list, clearing...");
            formik.setFieldValue("model", "");
          }
        }
      })
      .catch((err) => {
        console.log("Error fetching models:", err);
        setAssetModel([]);
        formik.setFieldValue("model", ""); // Clear model on error
      });
  };

  // Handle file selection
  const handleFiles = async (files) => {
    const newImages = await Promise.all(
      Array.from(files).map(async (file) => {
        // Create a promise to read the file as a Base64 string
        const base64String = await new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = reject;
          reader.readAsDataURL(file); // Reads the file as Base64
        });

        return {
          file, // original file (for potential use)
          base64: base64String, // Base64 string for storage or preview
          preview: URL.createObjectURL(file), // Optional: preview URL
        };
      })
    );

    const updatedImages = [...images, ...newImages];
    setImages(updatedImages);

    // Save to Formik
    formik.setFieldValue("images", updatedImages);

    // Clear the input field value
    if (inputRef && inputRef.current) {
      inputRef.current.value = "";
    }
  };

  // Handle drag-and-drop
  const handleDrop = (event) => {
    event.preventDefault();
    handleFiles(event.dataTransfer.files);
  };

  // Remove image
  const removeImage = (index) => {
    const updatedImages = images.filter((_, i) => i !== index);
    setImages(updatedImages);
    formik.setFieldValue("images", updatedImages);
  };

  // Open preview modal
  const openPreview = (image) => {
    setPreviewImage(image);
  };

  // Close preview modal
  const closePreview = () => {
    setPreviewImage(null);
  };

  const handleCheckUnitNumber = (values) => {
    setAddMachineLoader(true);
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    const payload = `number=${values.serialNumber}&isUnitNumber=false`;
    checkUnitNumber(payload, header, instance, accounts)
      .then((res) => {
        handleAddLocation(values);
      })
      .catch((err) => {
        toast.error(err.data.message);
        setAddMachineLoader(false);
      });
  };

  const handleAddLocation = (values) => {
    setAddMachineLoader(true);
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    const payload = {
      CompanyName: "",
      Address1: values.address1,
      Address2: values.address2,
      PostalCode: values.postalCode,
      Province: "",
      Country: values.country,
      City: values.city,
      locationOptions: [],
      LocationTypesJson: "[1]",
      LocationTypes: [1],
      Latitude: values.lat,
      Longitude: values.lng,
      LocationName: values.location,
      LocationTypesCount: 1,
      Comment: "",
      center: {
        lat: formik?.values.lat,
        lng: formik?.values.lng,
      },
      check: true,
      ShowSalesTaxModal: false,
      DisplayName: formik?.values.location,
      CompanyId: azureUserInfo?.CompanyId,
    };

    addLocation(payload, header, instance, accounts)
      .then((res) => {
        handleAddAsset({ ...values, LocationId: res?.data?.LocationId });
      })
      .catch((err) => {
        setAddMachineLoader(false);
        toast.error(err?.data);
      });
  };

  const handleAddAsset = (values) => {
    setAddMachineLoader(true);
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };

    const payload = {
      AssetStatusId: Number(values?.status),
      MakeId: Number(values?.manufacturers),
      AssetTypeId: DefaultAssetID,
      AssetDescription: values?.description,
      Year: Number(values?.year),
      Model: values?.model,
      SerialNumber: values?.serialNumber,
      Price: Number(values?.price),
      ContactId: azureUserInfo?.ContactId,
      CompanyId: azureUserInfo?.CompanyId,
      LocationId: Number(values?.LocationId),
      LastKnownSMU: values.machineHours,
      LastSMUDate: values.smu,
    };
    addAsset(payload, header, instance, accounts)
      .then((res) => {
        handleAddCategori(values, res.data);
      })
      .catch((err) => {
        setAddMachineLoader(false);
        toast.error(err?.data);
      });
  };

  const handleAddCategori = (values, assetInfo) => {
    const selectCatagory = assetType.find((item) => Number(item.CategoryId) == Number(values?.type));
    let payload = {
      AssetId: assetInfo?.AssetId,
      AssetTypeId: DefaultAssetID,
      CategoryId: Number(values?.type),
      CategorizationBreadcrumb: `Paving Equipment // ${selectCatagory.CategoryName}`,
      CategorizationJson: `{"AssetTypeId":{"key":2,"label":"Paving Equipment"},"CategoryId":{"key":${DefaultAssetID},"label":"${selectCatagory.CategoryName}"}}`,
    };
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };

    addCategori(payload, header, instance, accounts)
      .then((res) => {
        uploadImg(values, assetInfo);
      })
      .catch((err) => {
        setAddMachineLoader(false);
        toast.error(err?.data || "Error fetching companies");
      });
  };

  const uploadImg = async (values, assetInfo) => {
    try {
      const header = {
        authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
      };

      // Ensure `images` is available and not empty
      if (!images || images.length === 0) {
        toast.error("No images to upload!");
        return;
      }

      const files = images.map((base64String, index) => {
        const [meta, data] = base64String.base64.split(",");
        const mimeType = meta.match(/:(.*?);/)[1]; // Extract mime type from Base64 metadata

        // Convert Base64 data to binary and create a File object
        return new File(
          [
            new Uint8Array(
              atob(data)
                .split("")
                .map((char) => char.charCodeAt(0))
            ),
          ],
          `image${index + 1}.${mimeType.split("/")[1]}`, // Generate a file name with the extension
          { type: mimeType }
        );
      });

      const uploadPromises = files.map(async (item, index) => {
        const url = `pictureId=${assetInfo?.AssetId}&directoryName=Dev`;
        const payload = new FormData();
        payload.append("file", item);

        try {
          // Upload image
          const uploadResponse = await uploadBulkImg(payload, header, url, instance, accounts);

          // Prepare payload for saving the picture
          let imgPayload = {
            Context: "Asset",
            ContextId: assetInfo?.AssetId, // Replace Asset ID
            url: uploadResponse.data.url,
            PictureUuid: uploadResponse.data.pictureUuid,
            PictureContentType: uploadResponse.data.pictureContentType,
            FileSizeInBytes: uploadResponse.data.file.Length,
            FileName: uploadResponse.data.file.FileName.substring(
              0,
              uploadResponse.data.file.FileName.lastIndexOf(".")
            ),
            FileFullName: uploadResponse.data.file.FileName,
            folderFetachParam: {
              Context: "Asset",
              ContextId: assetInfo?.AssetId, // Replace Asset ID
            },
          };
          if (index == 0) {
            imgPayload = {
              ...imgPayload,
              Main: true, // this flag working for main img set in asset for 1st img
            };
          }
          // Save the picture
          const saveResponse = await savePicture(imgPayload, header);
        } catch (uploadErr) {
          console.error("Error uploading image:", uploadErr);
          toast.error(uploadErr?.data || "Image upload failed!");
          throw uploadErr; // Propagate error for outer handling
        }
      });

      // Wait for all uploads to finish
      await Promise.all(uploadPromises);
      handleAddAdvertisements(values, assetInfo);
    } catch (err) {
      console.error("Error in uploadImg:", err);
      toast.error("Failed to upload images!");
      setAddMachineLoader(false);
    } finally {
    }
  };

  const handleAddAdvertisements = async (values, assetInfo) => {
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    const url = `contactId=${azureUserInfo?.ContactId}`;

    const contactData = await getContactById(url, header, instance, accounts);
    const payload = {
      AdvertisedPrice: Number(values?.price),
      AdvertisedCurrency: values?.currency,
      AdStartDate: formatDate(new Date()),
      Description: values?.description,

      ContactName: contactData?.data?.ContactName,
      ContactEmail: contactData?.data?.Email,
      ContactPhone: contactData?.data?.Mobile,

      SortOrder: 1,
      AssetId: assetInfo?.AssetId, // Replace Asset ID
      AdvertiserId: 1,
      AdvertiserIds: [1],
    };
    addAssetAdvertisements(payload, header)
      .then((res) => {
        toast.success("List Add");
        localStorage.removeItem("StoreMachineData");
        localStorage.removeItem("StoreMachineImg");
        formik.resetForm();
        setImages([]);
        setAddMachineLoader(false);
      })
      .catch((err) => {
        setAddMachineLoader(false);
        toast.error(err?.data);
      });
  };

  const handleCloseWarning = () => {
    setOpenWarning(false);
  };

  const handleCloseWarningOnlyModel = () => {
    setOpenWarning(false);
  };

  const handleClosePendingWarning = () => {
    localStorage.removeItem("OpenWarning");
    setIsLoading(false);
    setOpenPendingWarning(false);
    navigate("/");
  };

  // Login
  const handleLogin = async () => {
    setIsLoading(true);

    setOpenWarning(false);
    try {
      const idToken = await instance.loginPopup(loginRequest);
      handleRedirectCallback(idToken.accessToken);
      localStorage.setItem("vizy-azure-token", idToken.accessToken);
    } catch (error) {
      console.error("Login error:", error);
      setIsLoading(false);
    }
  };

  const handleRedirectCallback = async (response) => {
    try {
      const decodedToken = jwtDecode(response);

      if (!decodedToken?.extension_UserStatus) {
        await handleDefaultLogin(decodedToken, response);
        return;
      }

      switch (decodedToken.extension_UserStatus) {
        case undefined:
        case "Pending":
          await handlePendingStatus();
          break;

        case "Approved":
          await handleApprovedStatus(decodedToken);
          break;

        default:
          await handleDefaultStatus();
          break;
      }
    } catch (error) {
      console.error("Error handling redirect callback:", error);
      setIsLoading(false);
    }
  };

  const handlePendingStatus = async () => {
    await instance.logoutPopup({ postLogoutRedirectUri: window.location.origin });
    handleOpenWarning();
    localStorage.removeItem("vizy-bility-token");
    localStorage.removeItem("client_info");
    setIsLoading(false);
  };

  const handleApprovedStatus = async (decodedToken) => {
    const payload = new URLSearchParams({
      grant_type: vizybilityConfig.grant_type,
      username: decodedToken.extension_GenericWebUsername,
      password: decodedToken.extension_GenericWebUserPassword,
      client_id: vizybilityConfig.STS_CLIENT_ID,
      client_secret: vizybilityConfig.STS_CLIENT_SECRET,
      scope: vizybilityConfig.STS_SCOPE,
      ApplicationId,
    });

    setIsLoading(true);
    try {
      const res = await postGetVizyBilityToken({
        url: vizybilityConfig.STS_SIGNIN_URL,
        payload,
      });

      if (res?.data?.access_token) {
        localStorage.setItem("vizy-bility-token", res.data.access_token);
        localStorage.setItem("client_info", JSON.stringify(decodedToken));

        const header = { authorization: `Bearer ${res.data.access_token}` };
        const ThirdPartyAzureToken = await getThirdPartyAzureService(header);
        const headerUser = {
          Authorization: `Bearer ${ThirdPartyAzureToken?.data?.access_token}`,
        };
        const getGenericUser = await getGenericUserKey(header);
        const applicationId = JSON.parse(getGenericUser?.data?.SettingValue)?.AzureB2CApplicationID;
        const query = `${decodedToken.sub}?$select=id,givenName,surname,identities,extension_${applicationId}_CreatedDatetime,extension_${applicationId}_UserStatus,extension_${applicationId}_ContactId,extension_${applicationId}_CompanyName,extension_${applicationId}_CompanyId,extension_${applicationId}_EmailAddresses,extension_${applicationId}_Phone,extension_${applicationId}_IsActive,extension_${applicationId}_DeactivationDatetime,extension_${applicationId}_ContactUserName`;
        const AzureUserData = await getAzureUser(query, headerUser);
        localStorage.setItem("getAzureUserData", JSON.stringify(cleanObjectKeys(AzureUserData?.data)));

        localStorage.removeItem("OpenWarning");
        setIsLoading(false);
        setOpenPendingWarning(false);
        window.location.reload();
      }
      setIsLoading(false);
    } catch (error) {
      await handlePendingStatus();
    }
  };

  const handleDefaultLogin = async (decodedToken, response) => {
    const payload = new URLSearchParams({
      grant_type: vizybilityConfig.grant_type,
      username: vizybilityConfig.GenericWebUsername,
      password: vizybilityConfig.GenericWebUserPassword,
      client_id: vizybilityConfig.STS_CLIENT_ID,
      client_secret: vizybilityConfig.STS_CLIENT_SECRET,
      scope: vizybilityConfig.STS_SCOPE,
      ApplicationId,
    });

    setIsLoading(true);
    try {
      const res = await postGetVizyBilityToken({
        url: vizybilityConfig.STS_SIGNIN_URL,
        payload,
      });

      if (res?.data?.access_token) {
        localStorage.setItem("vizy-bility-token", res.data.access_token);
        localStorage.setItem("client_info", JSON.stringify(decodedToken));
        localStorage.setItem("azuretoken", response);
        localStorage.setItem("vizy-azure-token", response);
        navigate("/admin");
      }
      setIsLoading(false);
    } catch (error) {
      await handlePendingStatus();
    }
  };

  const handleDefaultStatus = async () => {
    await handlePendingStatus();
  };

  const handleOpenWarning = () => {
    setOpenPendingWarning(true);
    localStorage.setItem("OpenWarning", true);
  };

  const handlePlaceSelect = (place, formik) => {
    const addressComponents = place?.address_components || [];

    const getComponent = (types) => {
      const component = addressComponents.find((comp) => comp.types.some((type) => types.includes(type)));
      return component ? component.long_name : "";
    };
    formik.setFieldValue(
      "location",
      `${place?.formatted_address} ${getComponent(["sublocality", "neighborhood"])} ${getComponent([
        "locality",
        "administrative_area_level_2",
      ])} ${getComponent(["administrative_area_level_1"])} ${getComponent(["country"])}` || formik.values.address1
    );
    formik.setFieldValue("address1", place?.formatted_address || formik.values.address1);
    formik.setFieldValue("address2", getComponent(["sublocality", "neighborhood"]) || "");
    formik.setFieldValue("city", getComponent(["locality", "administrative_area_level_2"]));
    formik.setFieldValue("state", getComponent(["administrative_area_level_1"]));
    formik.setFieldValue("country", getComponent(["country"]));
    formik.setFieldValue("postalCode", getComponent(["postal_code"]));
    formik.setFieldValue("lat", place?.geometry?.location?.lat());
    formik.setFieldValue("lng", place?.geometry?.location?.lng());
  };

  return (
    <>
      {isLoading || addMachineLoader ? (
        <div className="fixed w-[100%] h-[100dvh] bg-[#00000066] flex justify-center items-center z-50 top-0">
          <span class="loader"></span>
        </div>
      ) : null}
      <div className="bg-[#fff] pb-[100px]">
        <div className="custom-container">
          <div className="py-[29px]">
            <div className="text-[#161412] lg:text-[48px] md:text-[38px] sm:text-[28px] text-[18px] font-[Roboto] font-black	text-center mb-[30px]">
              {registeringForm.LIST_YOUR_MACHINE}
            </div>
            <form onSubmit={formik.handleSubmit}>
              <div className="p-[20px] bg-[#F2F2F2] rounded-lg mb-[20px]">
                <div
                  className="bg-white rounded-lg py-[50px] text-center cursor-pointer"
                  onDragOver={(e) => e.preventDefault()}
                  onDrop={handleDrop}
                  onClick={() => document.getElementById("fileInput").click()}
                >
                  <div className="flex item-center justify-center mb-[20px]">
                    <img src={Upload} alt="Upload" />
                  </div>
                  <div className="block text-[Roboto] text-[16px] font-normal text-[#A9A9A9]">
                    {registeringForm.DRAG_AND_DROP}
                  </div>
                  <input
                    type="file"
                    id="fileInput"
                    className="hidden"
                    multiple
                    accept="image/*"
                    ref={inputRef}
                    onChange={(e) => handleFiles(e.target.files)}
                  />
                </div>
                {formik.touched.images && formik.errors.images ? (
                  <p className="text-red-400 mt-1 text-[14px]">{formik.errors.images}</p>
                ) : null}

                <div className="mt-[20px] grid 2xl:grid-cols-5 lg:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-[20px]">
                  {images.map((image, index) => (
                    <div key={index} className="relative group border rounded-lg overflow-hidden">
                      {/* Image */}
                      <img src={image.base64} alt={`Preview ${index}`} className="w-full h-[170px] object-cover" />

                      {/* Hover Preview */}
                      <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        <div
                          className="text-white text-sm bg-gray-700 py-1 px-3 rounded hover:bg-gray-800 cursor-pointer"
                          onClick={() => openPreview(image.base64)}
                        >
                          Preview
                        </div>
                      </div>

                      {/* Remove Button */}
                      <button
                        className="absolute top-2 right-2 bg-red-600 text-white rounded-full p-1 text-xs hover:bg-red-700 w-[20px] h-[20px]"
                        onClick={() => removeImage(index)}
                      >
                        ✕
                      </button>
                    </div>
                  ))}
                </div>
              </div>

              <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-4">
                <div>
                  <label className="block text-[Roboto] text-[#000] text-[16px] font-normal">Year</label>
                  <input
                    type="number"
                    name="year"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.year}
                    placeholder="Enter here"
                    className="input bg-white border border-[#F2F2F2] text-black w-full rounded-md py-[14px] px-[15px] mt-[10px]  text-[16px] font-[Roboto] font-normal focus:outline-none rounded-lg"
                  />
                  {formik.touched.year && formik.errors.year ? (
                    <p className="text-red-400 mt-1 text-[14px]">{formik.errors.year}</p>
                  ) : null}
                </div>

                <div>
                  <label className="block text-[Roboto] text-[#000] text-[16px] font-normal">Manufacturer</label>
                  <select
                    name="manufacturers"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.manufacturers}
                    className="input bg-white border border-[#F2F2F2] text-black w-full rounded-md py-[14px] px-[15px] mt-[10px]  text-[16px] font-[Roboto] font-normal focus:outline-none rounded-lg"
                  >
                    <option value="" className="text-[16px] text-[#161616] font-[Roboto]" disabled>
                      <div className="!my-[10px] !mx-[30px] leading-[200px]">Select Manufacturers</div>
                    </option>
                    {assetMake.map((item) => {
                      return (
                        <option value={item.MakeId} className="text-[16px] text-[#161616] font-[Roboto]">
                          <div className="!my-[10px] !mx-[30px] leading-[200px]">{item.MakeName}</div>
                        </option>
                      );
                    })}
                  </select>
                  {formik.touched.manufacturers && formik.errors.manufacturers ? (
                    <p className="text-red-400 mt-1 text-[14px]">{formik.errors.manufacturers}</p>
                  ) : null}
                </div>

                <div>
                  <label className="block text-[Roboto] text-[#000] text-[16px] font-normal">Model</label>
                  <select
                    name="model"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.model}
                    className="input bg-white border border-[#F2F2F2] text-black w-full rounded-md py-[14px] px-[15px] mt-[10px]  text-[16px] font-[Roboto] font-normal focus:outline-none rounded-lg"
                  >
                    <option value="" className="text-[16px] text-[#161616] font-[Roboto]" disabled>
                      <div className="!my-[10px] !mx-[30px] leading-[200px]">Select Model</div>
                    </option>
                    {assetModel.map((item) => {
                      return (
                        <option key={item.ModelMasterId} value={item.ModelName} className="text-[16px] text-[#161616] font-[Roboto]">
                          <div className="!my-[10px] !mx-[30px] leading-[200px]">{item.ModelName}</div>
                        </option>
                      );
                    })}
                  </select>
                  {formik.touched.model && formik.errors.model ? (
                    <p className="text-red-400 mt-1 text-[14px]">{formik.errors.model}</p>
                  ) : null}
                </div>

                <div>
                  <label className="block text-[Roboto] text-[#000] text-[16px] font-normal">Serial Number</label>
                  <input
                    type="text"
                    name="serialNumber"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.serialNumber}
                    placeholder="Enter here"
                    className="input bg-white border border-[#F2F2F2] text-black w-full rounded-md py-[14px] px-[15px] mt-[10px]  text-[16px] font-[Roboto] font-normal focus:outline-none rounded-lg"
                  />
                  {formik.touched.serialNumber && formik.errors.serialNumber ? (
                    <p className="text-red-400 mt-1 text-[14px]">{formik.errors.serialNumber}</p>
                  ) : null}
                </div>

                <div>
                  <label className="block text-[Roboto] text-[#000] text-[16px] font-normal">Category</label>
                  <select
                    name="type"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.type}
                    className="input bg-white border border-[#F2F2F2] text-black w-full rounded-md py-[14px] px-[15px] mt-[10px]  text-[16px] font-[Roboto] font-normal focus:outline-none rounded-lg"
                  >
                    <option value="" className="text-[16px] text-[#161616] font-[Roboto]" disabled>
                      <div className="!my-[10px] !mx-[30px] leading-[200px]">Select Category</div>
                    </option>
                    {assetType.map((item) => {
                      return (
                        <option value={item.CategoryId} className="text-[16px] text-[#161616] font-[Roboto]">
                          <div className="!my-[10px] !mx-[30px] leading-[200px]">{item.CategoryName}</div>
                        </option>
                      );
                    })}
                  </select>
                  {formik.touched.type && formik.errors.type ? (
                    <p className="text-red-400 mt-1 text-[14px]">{formik.errors.type}</p>
                  ) : null}
                </div>

                <div>
                  <label className="block text-[Roboto] text-[#000] text-[16px] font-normal">Machine Hours As of</label>
                  <input
                    type="date"
                    name="smu"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.smu}
                    placeholder="Enter here"
                    className="input bg-white border border-[#F2F2F2] text-black w-full rounded-md py-[14px] px-[15px] mt-[10px]  text-[16px] font-[Roboto] font-normal focus:outline-none rounded-lg"
                  />
                  {formik.touched.smu && formik.errors.smu ? (
                    <p className="text-red-400 mt-1 text-[14px]">{formik.errors.smu}</p>
                  ) : null}
                </div>

                <div>
                  <label className="block text-[Roboto] text-[#000] text-[16px] font-normal">Machine Hours</label>
                  <input
                    type="number"
                    name="machineHours"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.machineHours}
                    placeholder="Enter here"
                    className="input bg-white border border-[#F2F2F2] text-black w-full rounded-md py-[14px] px-[15px] mt-[10px]  text-[16px] font-[Roboto] font-normal focus:outline-none rounded-lg"
                  />
                  {formik.touched.machineHours && formik.errors.machineHours ? (
                    <p className="text-red-400 mt-1 text-[14px]">{formik.errors.machineHours}</p>
                  ) : null}
                </div>

                {/* <div>
                  <label className="block text-[Roboto] text-[#000] text-[16px] font-normal">Sort Order</label>
                  <input
                    type="number"
                    name="sortOrder"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.sortOrder}
                    placeholder="Enter here"
                    className="input bg-white border border-[#F2F2F2] text-black w-full rounded-md py-[14px] px-[15px] mt-[10px]  text-[16px] font-[Roboto] font-normal focus:outline-none rounded-lg"
                  />
                  {formik.touched.sortOrder && formik.errors.sortOrder ? (
                    <p className="text-red-400 mt-1 text-[14px]">{formik.errors.sortOrder}</p>
                  ) : null}
                </div> */}

                {/* <div>
                  <label className="block text-[Roboto] text-[#000] text-[16px] font-normal">Status</label>
                  <select
                    name="status"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.status}
                    className="input bg-white border border-[#F2F2F2] text-black w-full rounded-md py-[14px] px-[15px] mt-[10px]  text-[16px] font-[Roboto] font-normal focus:outline-none rounded-lg"
                  >
                    <option value="" className="text-[16px] text-[#161616] font-[Roboto]" disabled>
                      <div className="!my-[10px] !mx-[30px] leading-[200px]">Select Status</div>
                    </option>
                    {assetStatus.map((item) => {
                      return (
                        <option value={item.AssetStatusId} className="text-[16px] text-[#161616] font-[Roboto]">
                          <div className="!my-[10px] !mx-[30px] leading-[200px]">{item.AssetStatusName}</div>
                        </option>
                      );
                    })}
                  </select>
                  {formik.touched.status && formik.errors.status ? (
                    <p className="text-red-400 mt-1 text-[14px]">{formik.errors.status}</p>
                  ) : null}
                </div> */}

                <div>
                  <label className="block text-[Roboto] text-[#000] text-[16px] font-normal">Price</label>
                  <input
                    type="number"
                    name="price"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.price}
                    placeholder="Enter here"
                    className="input bg-white border border-[#F2F2F2] text-black w-full rounded-md py-[14px] px-[15px] mt-[10px]  text-[16px] font-[Roboto] font-normal focus:outline-none rounded-lg"
                  />
                  {formik.touched.price && formik.errors.price ? (
                    <p className="text-red-400 mt-1 text-[14px]">{formik.errors.price}</p>
                  ) : null}
                </div>

                <div>
                  <label className="block text-[Roboto] text-[#000] text-[16px] font-normal">Currency</label>
                  <select
                    name="currency"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.currency}
                    className="input bg-white border border-[#F2F2F2] text-black w-full rounded-md py-[14px] px-[15px] mt-[10px]  text-[16px] font-[Roboto] font-normal focus:outline-none rounded-lg"
                  >
                    <option value="" className="text-[16px] text-[#161616] font-[Roboto]" disabled>
                      <div className="!my-[10px] !mx-[30px] leading-[200px]">Select Currency</div>
                    </option>
                    <option className="text-[16px] text-[#161616] font-[Roboto]" value={"CAD"}>
                      CAD
                    </option>
                    <option className="text-[16px] text-[#161616] font-[Roboto]" value={"USD"}>
                      USD
                    </option>
                  </select>
                  {formik.touched.currency && formik.errors.currency ? (
                    <p className="text-red-400 mt-1 text-[14px]">{formik.errors.currency}</p>
                  ) : null}
                </div>

                {/* <GooglePlacesAutocomplete
                    apiKey={Google_map_Key}
                    onPlaceSelected={(place) => handlePlaceSelect(place, formik)}
                    value={formik.values.location}
                    onChange={(e) => {
                      formik.setValues({
                        ...formik.values,
                        location: e.target.value,
                      });
                    }}
                    options={{
                      types: ["address"],
                    }}
                    className="input bg-white border border-[#F2F2F2] text-black w-full rounded-md py-[14px] px-[15px] mt-[10px]  text-[16px] font-[Roboto] font-normal focus:outline-none rounded-lg"
                  />
                  {formik.touched.location && formik.errors.location ? (
                    <p className="text-red-400 mt-1 text-[14px]">{formik.errors.location}</p>
                  ) : null} */}
              </div>

              <div className="mt-[20px]">
                <label className="block text-[Roboto] text-[#000] text-[16px] font-normal">Description</label>
                <textarea
                  type="text"
                  name="description"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.description}
                  placeholder="Enter here"
                  className="input bg-white border border-[#F2F2F2] text-black w-full rounded-md py-[14px] px-[15px] mt-[10px]  text-[16px] font-[Roboto] font-normal focus:outline-none rounded-lg"
                />
                {formik.touched.description && formik.errors.description ? (
                  <p className="text-red-400 mt-1 text-[14px]">{formik.errors.description}</p>
                ) : null}
              </div>

              {/* <div className="mt-[20px] text-center">
                <div className="font-bold text-[16px] font-bold font-[Roboto] underline underline-offset-4 cursor-pointer text-[#161412]">
                  {registeringForm.MORE_FIELD}
                </div>
              </div> */}

              <div className="mt-[30px] text-center">
                <button
                  disabled={addMachineLoader}
                  type="submit"
                  className="border border-[#FEBA06] bg-[#FEBA06] px-[90px] py-[15px] font-bold text-[16px] font-bold font-[Roboto] rounded-lg text-[#161412]"
                >
                  {registeringForm.LIST_MY_MACHINE}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* Modal for Preview */}
      {previewImage && (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
          <div className="relative bg-white p-4 rounded-lg max-w-[90%] max-h-[90%]">
            <div
              className="absolute top-2 right-2 bg-red-600 text-white rounded-full p-2 hover:bg-red-700  w-[30px] h-[30px] cursor-pointer flex items-center justify-center"
              onClick={closePreview}
            >
              ✕
            </div>
            <img src={previewImage} alt="Preview" className="max-w-full max-h-[80vh] object-contain" />
          </div>
        </div>
      )}

      <SignUpWarningModel
        open={openWarning}
        setOpen={setOpenWarning}
        handleClose={handleCloseWarning}
        handleCloseWarningOnlyModel={handleCloseWarningOnlyModel}
        handleLogin={handleLogin}
      />

      <WarningModal open={openPendingWarning} handleClose={handleClosePendingWarning} />
    </>
  );
};
export default AddMachineForm;
